<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500 align-top">
      <a role="button" @click.prevent="handleOpenEmailCampaignDialog">
        {{ emailCampaign.name }}
      </a>

      <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ emailCampaign.email_addresses_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Unique Recipients</dt>
        </div>

        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ emailCampaign.email_addresses_sent_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Sent</dt>
        </div>

        <div class="px-4 py-3 bg-white shadow rounded-lg overflow-hidden">
          <dd class="mb-1 font-semibold text-gray-900">
            {{ emailCampaign.email_addresses_failed_count }}
          </dd>
          <dt class="text-xs font-medium text-gray-500 truncate">Failed</dt>
        </div>
      </dl>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-left align-top">
      {{ status }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-left align-top">
      <span v-if="startsAt && emailCampaign.status === 'PENDING'">{{ startsAt }}</span>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500 text-right align-top">
      <span class="whitespace-nowrap">{{ createdAt }}</span>
      <div>
        {{ createdAtFromNow }}
      </div>
    </td>
    <td class="w-0 align-top p-4">
      <MoreAction
        v-if="$membershipHasPermissionTo('delete email campaigns')"
        :email-campaign="emailCampaign"
        @deleted="$emit('deleted')"
      />
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import { capitalize } from 'lodash-es';
import MoreAction from './MoreAction.vue';

export default {
  components: {
    MoreAction,
  },
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    status() {
      const { status = '' } = this.emailCampaign;

      return status ? capitalize(status) : 'N/A';
    },
    startsAt() {
      if (!this.emailCampaign.starts_at) {
        return null;
      }

      return moment.utc(this.emailCampaign.starts_at).local().format('DD-MM-YYYY HH:mm');
    },
    createdAt() {
      return moment.utc(this.emailCampaign.created_at).local().format('DD-MM-YYYY HH:mm');
    },
    createdAtFromNow() {
      return moment.utc(this.emailCampaign.created_at).local().fromNow();
    },
    canEdit() {
      return ['DRAFT', 'CANCELLED', 'FAILED'].indexOf(this.emailCampaign.status) >= 0;
    },
  },
  methods: {
    handleOpenEmailCampaignDialog() {
      if (this.canEdit) {
        this.openEditEmailCampaignDialog();
        return;
      }

      this.openViewEmailCampaignDialog();
    },
    openEditEmailCampaignDialog() {
      this.$modal.show({
        component: () =>
          import('@/components/EmailCampaign/EditEmailCampaignDialog/EditEmailCampaignDialog.vue'),
        props: {
          emailCampaignId: this.emailCampaign.id,
        },
        on: {},
        hideEvent: 'close',
      });
    },
    openViewEmailCampaignDialog() {
      this.$modal.show({
        component: () =>
          import('@/components/EmailCampaign/ViewEmailCampaignDialog/ViewEmailCampaignDialog.vue'),
        props: {
          emailCampaignId: this.emailCampaign.id,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
